
<form class="w-full flex flex-row gap-4 items-center">
    <mat-form-field class="w-full" appearance="outline">
      <input matInput [formControl]="url" placeholder="{{placeholderUrl}}">
      @if (url.invalid) {
        <mat-error>{{errorMessage()}}</mat-error>
      }
    </mat-form-field>
    <button matButton (click)="addPlaylist()">Add</button>
</form>
